import { Image } from 'antd'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { useCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { DelaysList } from '@/Containers/AssignmentSection/AssignmentContainer/Components/Sections/DelaysList'
import { ResolveDelayModal } from '@/Ship/Components/Modals/ResolveDelayModal'

import { collectAssignments, taskLabel } from '../../Helpers/assignmentCollectors'
import { getRequestExecutorPermissions } from '../../Helpers/permissions'
import { TaskDelaysTabStore } from '../../Stores/TaskDelaysTabStore'

/**
 * Вкладка «Затримки» картки заявки: затримки всіх завдань однією стрічкою (новіші зверху),
 * тим самим `DelaysList`, що й у картці задачі, з підписом завдання над кожною.
 * «Вирішити» — для відкритих затримок, коли користувач може керувати завданнями.
 */
export const TaskDelaysTab = observer(({ formContext }: any) => {
    const [store] = useState(() => new TaskDelaysTabStore())
    const crudContext = useCrudResourceContext()

    // Затримка знає своє завдання через `_task`: DelaysList приймає плоский список
    const delays = collectAssignments(formContext).flatMap((task: any) =>
        (task.delays ?? []).map((delay: any) => ({ ...delay, _task: task }))
    )
    const canResolve = getRequestExecutorPermissions(null).canManageTasks

    return (
        <>
            <DelaysList
                delays={delays}
                canResolve={canResolve}
                itemLabel={(delay) => taskLabel(delay._task)}
                onShowPhotos={(urls) => store.showPhotos(urls)}
                onResolve={(delay) => store.openResolveModal(delay)}
            />
            <Image.PreviewGroup
                preview={{
                    visible: store.previewOpen,
                    onVisibleChange: (visible: boolean) => store.setPreviewOpen(visible),
                    current: 0,
                }}
                items={store.previewPhotos.map((url) => ({ src: url }))}
            />
            <ResolveDelayModal
                delay={store.selectedDelay}
                open={store.open}
                onClose={() => store.closeResolveModal()}
                onResolved={() => crudContext?.actions?.reloadData?.()}
            />
        </>
    )
})
